<div class="view-loader-box">
    <div class="view-loader-icon">
        <svg class="view-loader-ring" viewBox="0 0 48 48">
            <circle class="view-loader-ring-track" cx="24" cy="24" r="20"></circle>
            <circle class="view-loader-ring-arc" cx="24" cy="24" r="20"></circle>
        </svg>
        <mat-icon svgIcon="culteva:icon" class="view-loader-brand"></mat-icon>
    </div>
    <div class="view-loader-message">{{ message }}</div>
</div>